export default function pluralize(subject, singular, plural) {
  const count =
    typeof subject === 'number'
      ? subject
      : Array.isArray(subject)
      ? subject.length
      : Object.keys(subject).length

  // "In English, only one number is singular: one."
  return (count === 1 || count === -1 ? singular : plural).replace('{}', count)
}
